module fdm.common{

    angular.module('fdm.common')
        .config(['$httpProvider', ($httpProvider: ng.IHttpProvider) => {

        }]);
}